import { gql } from "@apollo/client";

const OrientedImagery = gql`
  query OrientedImagery($projectName: String!) {
    orientedPhotos(tprojectName: $projectName) {
      nodes {
        X: x
        Y: y
        Z: z
        SRS: srs
        ImagePath: url
        Name: name
        AcquisitionDate: acquisitionDate
        CameraHeading: cameraHeading
        OrientedImageryType: imageryType
      }
    }
  }
`;

const hash = "a984c3f1be6277319b77a3cfa86f2893eea6ea71a255fd7504f85f43d243b862";

export { OrientedImagery, hash };
